var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"pf-step-navigation"},_vm._l((_vm.steps),function(step){return _c('li',[_c('a',{class:_vm.stepStatus(step)},[_c('span',[_vm._v(_vm._s(step))]),_c('font-awesome-icon',{attrs:{"icon":"check"}})],1)])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }